module.exports = __webpack_public_path__ + "img/pricing_sell_black@2x.1880ffdc.png";